module.exports = "/_next/static/images/customer-review-claudia@2x-min-32c7507ef2fa2fcf631a2c57dae3dbbb.png.webp";